import { useDispatch } from "react-redux";
import Box from "../../../../components/Box";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { GetCompanyListResponseItem } from "../../../../models/response/company/GetCompanyListResponse";
import { storeFastFirm } from "../../../../redux/reducers/authSlice";
import { CompanyService } from "../../../../services/CompanyService";
import { ConstantService } from "../../../../services/ConstantService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";

interface Props {
    saleInformationRef: any
    selectedSaleCompany: CustomSingleSelectModel | undefined
    setSelectedSaleCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    saleTcknVkn: string | undefined
    setSaleTcknVkn: React.Dispatch<React.SetStateAction<string | undefined>>
    salePrice: string | undefined
    setSalePrice: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedSaleCurrency: CustomSingleSelectModel | undefined
    setSelectedSaleCurrency: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    saleProxyPersonName: string | undefined
    setSaleProxyPersonName: React.Dispatch<React.SetStateAction<string | undefined>>
    saleProxyStartDate: string | undefined
    setSaleProxyStartDate: React.Dispatch<React.SetStateAction<string | undefined>>
    saleProxyEndDate: string | undefined
    setSaleProxyEndDate: React.Dispatch<React.SetStateAction<string | undefined>>
    saleDesc: string | undefined
    setSaleDesc: React.Dispatch<React.SetStateAction<string | undefined>>
}

const SaleInformation = ({
    saleInformationRef,
    selectedSaleCompany,
    setSelectedSaleCompany,
    saleTcknVkn,
    setSaleTcknVkn,
    salePrice,
    setSalePrice,
    selectedSaleCurrency,
    setSelectedSaleCurrency,
    saleProxyPersonName,
    setSaleProxyPersonName,
    saleProxyStartDate,
    setSaleProxyStartDate,
    saleProxyEndDate,
    setSaleProxyEndDate,
    saleDesc,
    setSaleDesc,
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={saleInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Satış Bilgileri</h4>

                    <div className='row'>
                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Satılan Firma</label>

                                <CustomSingleSelect
                                    selectedValue={selectedSaleCompany}
                                    onChange={setSelectedSaleCompany}
                                    insertable={{
                                        tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                        onClick: () => {
                                            dispatch(storeFastFirm({
                                                companyId: selectedSaleCompany?.value,
                                                isCustomer: true,
                                                onSubmit: async (response) => {
                                                    setSelectedSaleCompany({ label: response.name, value: response.companyId })
                                                }
                                            }))
                                        }
                                    }}
                                    onMenuOpen={() => CompanyService.getCompanyList({ isCustomer: true })}
                                    labelName='name'
                                    valueName='companyId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Vergi No / TC Kimlik No</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={saleTcknVkn} onChange={(e) => setSaleTcknVkn(e.target.value)} type="number" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Satış Fiyatı / Döviz Cinsi</label>

                                <Box flexDirection="row">
                                    <Box mr="15px" flexGrow={1} justifyContent="center">
                                        <input style={{ border: '1px solid #F1F1F4' }} value={salePrice} onChange={(e) => setSalePrice(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </Box>
                                    <Box justifyContent="center">
                                        <CustomSingleSelect
                                            selectedValue={selectedSaleCurrency}
                                            onChange={setSelectedSaleCurrency}
                                            onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                            labelName='additionalValue1'
                                            valueName="constantId"
                                        />
                                    </Box>
                                </Box>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Vekalet Verilen Kişi</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={saleProxyPersonName} onChange={(e) => setSaleProxyPersonName(e.target.value)} type="text" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Vekalet Başlangıç Tarihi</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={saleProxyStartDate} onChange={(e) => setSaleProxyStartDate(e.target.value)} type="date" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Vekalet Bitiş Tarihi</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={saleProxyEndDate} onChange={(e) => setSaleProxyEndDate(e.target.value)} type="date" className="form-control form-control-solid" />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <Box height="100%">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Satış Açıklaması</label>
                                <textarea value={saleDesc} onChange={(e) => setSaleDesc(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', height: '100%', resize: 'none' }} className="form-control form-control-solid" />
                            </Box>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default SaleInformation;